import React, { Fragment, useState } from "react";
import DataTable from "react-data-table-component";
// import { currencyFormat } from "../../utils/currencyFormater";
import moment from "moment";
import DataTableExtensions from "react-data-table-component-extensions";
import "./gameHistory.css";
import InvetoryPopupModel from "./InvetoryPopupModel";
import { RustyRoyalCoin } from "../../utils/SvgIcons";

const GameTransactionHistoryTable = ({ myData }) => {
  const [modalShow, setModalShow] = useState(false);
  const [item, setItem] = useState([]);
  const handleOpenPopup = (row) => {
    setItem(row?.betItems || []);
    setModalShow(true);
  };
  const columns = [
    {
      name: "User ID",
      selector: (row) => row?.userId?._id || "N/A",
      sortable: true,
    },
    {
      name: "User Name",
      selector: (row) => row?.userId?.username || "N/A",
      sortable: true,
    },
    {
      name: "Bet Amount",
      cell: (row) => (
        <p className="d-flex m-0" style={{}}>
          <RustyRoyalCoin size={16} />{" "}
          <div className="pl-1">{row.betAmount.toFixed(2)}</div>
        </p>
      ),
      sortable: true,
    },
    {
      name: "Win Amount",

      cell: (row) => (
        <p className="d-flex m-0" style={{}}>
          <RustyRoyalCoin size={16} />{" "}
          <div className="pl-1">{row.winAmount.toFixed(2)}</div>
        </p>
      ),
      sortable: true,
    },

    {
      name: "Game Type",
      selector: (row) => row.type || "N/A",
      sortable: true,
    },

    {
      name: "Nonce",
      selector: (row) => row.nonce || "N/A",
      sortable: true,
    },
    {
      name: "Transaction Date",
      selector: (row) => moment(row.createdAt).format("DD/MM/YYYY HH:mm"),
      sortable: true,
    },
    {
      name: "Bet Items",
      selector: (row) =>
        row.type === "Jackpot" ||
        row.type === "CoinFlip" ||
        row.type === "Upgrader" ? (
          <button
            className="action-bt-of-history btn btn-primary"
            onClick={() => handleOpenPopup(row)}>
            Show
          </button>
        ) : (
          "-"
        ),
      sortable: true,
    },
  ];
  return (
    <div>
      <Fragment>
        <DataTableExtensions
          columns={columns}
          data={myData}
          print={false}
          export={false}>
          <DataTable
            data={myData}
            columns={columns}
            className={myData}
            pagination
            striped={true}
            center={true}
            // selectableRows
            // clearSelectedRows={selectedRows}
            // onSelectedRowsChange={(e) => handleSelectUsers(e)}
          />
        </DataTableExtensions>
      </Fragment>
      <InvetoryPopupModel
        show={modalShow}
        onHide={() => setModalShow(false)}
        item={item}
      />
    </div>
  );
};

export default GameTransactionHistoryTable;
